import React from "react";
import App from "App";
import paths, { rootPaths } from "./paths";
import { Navigate, createBrowserRouter } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";

import AuthSimpleLayout from "../layouts/AuthSimpleLayout";
import MainLayout from "../layouts/MainLayout";
import ErrorLayout from "../layouts/ErrorLayout";
import Calendar from "components/app/calendar/Calendar";
// import UserDetails from 'components/app/e-commerce/users/UserDetails';
import Tasks from "components/olitask/tasks";
import TaskDetailsPage from "components/olitask/tasks/TaskDetails";
import Users from "components/olitask/users";
import Chat from "components/app/chat/Chat";

import Error404 from "components/errors/Error404";
import Error500 from "components/errors/Error500";

import SimpleLogin from "components/authentication/simple/Login";
import SimpleLogout from "components/authentication/simple/Logout";
import SimpleRegistration from "components/authentication/simple/Registration";
import SimpleForgetPassword from "components/authentication/simple/ForgetPassword";
import SimpleVerificationCode from "components/authentication/simple/VerificationCode";
import SimplePasswordReset from "components/authentication/simple/PasswordReset";
import SimpleAccountRecoverySuccess from "components/authentication/simple/AccountRecoverySuccess";
import CardLogin from "components/authentication/card/Login";
import CardLogout from "components/authentication/card/Logout";
import CardRegistration from "components/authentication/card/Registration";
import CardForgetPassword from "components/authentication/card/ForgetPassword";
import CardConfirmMail from "components/authentication/card/ConfirmMail";
import CardPasswordReset from "components/authentication/card/PasswordReset";
import CardLockScreen from "components/authentication/card/LockScreen";
import Dashboard from "components/dashboards";
import VerticalNavLayout from "layouts/VerticalNavLayout";
import TopNavLayout from "layouts/TopNavLayout";
import ComboNavLayout from "layouts/ComboNavLayout";
import DoubleTopNavLayout from "layouts/DoubleTopNavLayout";
import UserAgreements from "components/general/userAgreements";
import UserAgreementForm from "components/general/userAgreements/form";
import UserAgreementDetails from "components/general/userAgreements/details";
import ActiveAgreement from "components/general/userAgreements/activeAgreement";
import { ApiKeys } from "components/general/apiKeys";
import { ClientIDs } from "components/general/clientIDs";
import UserDetails from "components/olitask/users/UserDetails";
import UserIdentityDocuments from "components/olitask/users/IdentityDocuments";
import { DonationsDashboard } from "components/olitask/donations/dashboard";
import { DonationsPuporses } from "components/olitask/donations/purposes";
import UserFormPage from "components/olitask/users/UserFormPage";
import Profile from "components/pages/user/profile/Profile";
import ProfileReviewsPage from "components/olitask/users/ProfileReviewsPage";
import Reviews from "components/olitask/tasks/taskReviews";
import { DonationsTable } from "components/olitask/donations/donationstable";
import { DonationDetails } from "components/olitask/donations/donationstable/DonationDetails";
import { CreditsTable } from "components/olitask/donations/credits";
import { CreditDetails } from "components/olitask/donations/credits/CreditDetails";
import { DonorDonations } from "components/olitask/donations/donationstable/DonorDonations";
import { IssueCreditPage } from "components/olitask/donations/credits/IssueCreditPage";
import { CreditApplications } from "components/olitask/donations/credit_applications";
import { ApplicationDetails } from "components/olitask/donations/credit_applications/ApplicationDetails";
import { IssueApplicationCredit } from "components/olitask/donations/credit_applications/IssueApplicationCredit";

//account management components
import SecurityQnsTable from "components/accountManagement/SecurityQns";
import PasswordReset from "components/accountManagement/AccountRecovery/passwordReset";
import AccountSecurityQuestions from "components/accountManagement/AccountRecovery";
import CreateNewPassword from "components/accountManagement/AccountRecovery/resetPassword";
import ChangePassword from "components/accountManagement/changePassword";
import RolesManagement from "components/access-control/roles";
import PrivilegeManagement from "components/access-control/privileges";
import AssignRole from "components/access-control/assign-role";
import RoleDetails from "components/access-control/roles/RoleDetails";
import Guard from "components/access-control/rbac/Guard";
import Unauthorised from "components/access-control/rbac/Unauthorised";
import { PRIV } from "components/access-control/rbac/privileges";
import TaskCategories from "components/olitask/tasks/categories/TaskCategories";
const routes = [
  {
    element: <App />,
    children: [
      {
        path: rootPaths.errorsRoot,
        element: <ErrorLayout />,
        children: [
          {
            path: paths.error404,
            element: <Error404 />,
          },
          {
            path: paths.error500,
            element: <Error500 />,
          },
        ],
      },
      {
        path: rootPaths.authRoot,
        children: [
          {
            path: rootPaths.authSimpleRoot,
            element: <AuthSimpleLayout />,
            children: [
              {
                path: paths.simpleLogin,
                element: (
                  <PublicRoute>
                    <SimpleLogin />
                  </PublicRoute>
                ),
              },
              {
                path: paths.simpleRegister,
                element: (
                  <PublicRoute>
                    <SimpleRegistration />
                  </PublicRoute>
                ),
              },
              {
                path: paths.simpleLogout,
                element: <SimpleLogout />,
              },
              {
                path: paths.simpleForgotPassword,
                element: <PasswordReset />,
              },

              {
                path: paths.simpleVerificationCode,
                element: <SimpleVerificationCode />,
              },
              {
                path: paths.simpleResetPassword,
                element: <SimplePasswordReset />,
              },
              {
                path: paths.simpleAccountRecoverySuccess,
                element: <SimpleAccountRecoverySuccess />,
              },
            ],
          },
          {
            path: rootPaths.authSplitRoot,
            children: [
              {
                path: paths.splitForgotPassword,
                element: <AccountSecurityQuestions />,
              },
              {
                path: paths.splitResetPassword,
                element: <CreateNewPassword />,
              },
            ],
          },

          {
            path: rootPaths.authCardRoot,
            children: [
              {
                path: paths.cardLogin,
                element: (
                  <PublicRoute>
                    <CardLogin />
                  </PublicRoute>
                ),
              },
              {
                path: paths.cardRegister,
                element: (
                  <PublicRoute>
                    <CardRegistration />
                  </PublicRoute>
                ),
              },
              {
                path: paths.cardLogout,
                element: <CardLogout />,
              },
              {
                path: paths.cardForgotPassword,
                element: <CardForgetPassword />,
              },
              {
                path: paths.cardResetPassword,
                element: <CardPasswordReset />,
              },
              {
                path: paths.cardConfirmMail,
                element: <CardConfirmMail />,
              },
              {
                path: paths.cardLockScreen,
                element: <CardLockScreen />,
              },
            ],
          },
        ],
      },
      {
        path: "/",
        element: (
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: <Dashboard />,
          },

          // olitask components
          {
            path: rootPaths.olitaskRoot,
            children: [
              {
                path: paths.users,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_USERS}
                    fallback={<Unauthorised />}
                  >
                    <Users />
                  </Guard>
                ),
              },
              {
                path: paths.userAdd,
                element: (
                  <Guard
                    privilege={PRIV.CREATE_USERS}
                    fallback={<Unauthorised />}
                  >
                    <UserFormPage />
                  </Guard>
                ),
              },
              {
                path: paths.userDetails(),
                element: (
                  <Guard
                    privilege={PRIV.VIEW_USERS}
                    fallback={<Unauthorised />}
                  >
                    <UserDetails />
                  </Guard>
                ),
              },

              {
                path: paths.userEdit(),
                element: (
                  <Guard
                    privilege={PRIV.UPDATE_USERS}
                    fallback={<Unauthorised />}
                  >
                    <UserFormPage />
                  </Guard>
                ),
              },
              {
                path: paths.reviewsTaskReviews(),
                element: <Reviews />,
              },
              {
                path: paths.profileReviews(),
                element: <ProfileReviewsPage />,
              },

              {
                path: paths.identityDocuments(),
                element: (
                  <Guard
                    privilege={PRIV.VERIFY_USERS}
                    fallback={<Unauthorised />}
                  >
                    <UserIdentityDocuments />
                  </Guard>
                ),
              },
              {
                path: paths.taskCategories,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_TASKS}
                    fallback={<Unauthorised />}
                  >
                    <TaskCategories />
                  </Guard>
                ),
              },
              {
                path: paths.tasks,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_TASKS}
                    fallback={<Unauthorised />}
                  >
                    <Tasks />
                  </Guard>
                ),
              },
              {
                path: paths.taskDetails(),
                element: (
                  <Guard
                    privilege={PRIV.VIEW_TASKS}
                    fallback={<Unauthorised />}
                  >
                    <TaskDetailsPage />
                  </Guard>
                ),
              },
              {
                path: paths.donationsList,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_DONATIONS}
                    fallback={<Unauthorised />}
                  >
                    <DonationsTable />
                  </Guard>
                ),
              },
              {
                path: paths.donationDetails(),
                element: (
                  <Guard
                    privilege={PRIV.VIEW_DONATIONS}
                    fallback={<Unauthorised />}
                  >
                    <DonationDetails />
                  </Guard>
                ),
              },
              {
                path: paths.donorDonations(),
                element: <DonorDonations />,
              },
              {
                path: paths.donationsPurposes,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_PURPOSES}
                    fallback={<Unauthorised />}
                  >
                    <DonationsPuporses />
                  </Guard>
                ),
              },
              {
                path: paths.donationsCredit,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_CREDITS}
                    fallback={<Unauthorised />}
                  >
                    <CreditsTable />
                  </Guard>
                ),
              },
              {
                path: paths.creditDetails(),
                element: (
                  <Guard
                    privilege={PRIV.VIEW_CREDITS}
                    fallback={<Unauthorised />}
                  >
                    <CreditDetails />
                  </Guard>
                ),
              },
              {
                path: paths.creditApplications,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_APPLICATIONS}
                    fallback={<Unauthorised />}
                  >
                    <CreditApplications />
                  </Guard>
                ),
              },
              {
                path: paths.applicationDetails(),
                element: (
                  <Guard
                    privilege={PRIV.VIEW_APPLICATIONS}
                    fallback={<Unauthorised />}
                  >
                    <ApplicationDetails />
                  </Guard>
                ),
              },
              {
                path: paths.issueCredit(),
                element: (
                  <Guard
                    privilege={PRIV.ISSUE_CREDIT}
                    fallback={<Unauthorised />}
                  >
                    <IssueCreditPage />
                  </Guard>
                ),
              },
              {
                path: paths.issueCreditFromApplication(),
                element: (
                  <Guard
                    privilege={PRIV.ISSUE_CREDIT}
                    fallback={<Unauthorised />}
                  >
                    <IssueApplicationCredit />
                  </Guard>
                ),
              },
            ],
          },
          //account management components
          {
            path: rootPaths.accountRoot,
            children: [
              {
                path: paths.securityQuestions,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_SECURITY_QUESTIONS}
                    fallback={<Unauthorised />}
                  >
                    <SecurityQnsTable />
                  </Guard>
                ),
              },
              {
                path: paths.passwordReset,
                element: <PasswordReset />,
              },
              {
                path: paths.createNewPassword,
                element: <CreateNewPassword />,
              },
              {
                path: paths.accountSecurityQns,
                element: <AccountSecurityQuestions />,
              },
              {
                path: paths.changePassword,
                element: <ChangePassword />,
              },
            ],
          },

          // access control components
          {
            path: rootPaths.accessControlRoot,
            children: [
              {
                path: paths.roles,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_ROLES}
                    fallback={<Unauthorised />}
                  >
                    <RolesManagement />
                  </Guard>
                ),
              },
              {
                path: paths.roleDetails(),
                element: (
                  <Guard
                    privilege={PRIV.VIEW_ROLES}
                    fallback={<Unauthorised />}
                  >
                    <RoleDetails />
                  </Guard>
                ),
              },
              {
                path: paths.privileges,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_PRIVILEGES}
                    fallback={<Unauthorised />}
                  >
                    <PrivilegeManagement />
                  </Guard>
                ),
              },
              {
                path: paths.assignRole,
                element: <AssignRole />,
              },
            ],
          },

          // general components
          {
            path: rootPaths.userRoot,
            children: [
              {
                path: paths.userProfile,
                element: <Profile />,
              },
            ],
          },

          {
            path: rootPaths.generalRoot,
            children: [
              {
                path: paths.agreements,
                element: <UserAgreements />,
              },
              {
                path: paths.agreementAdd,
                element: <UserAgreementForm />,
              },
              {
                path: paths.agreementEdit(),
                element: <UserAgreementForm />,
              },
              {
                path: paths.agreementDetails(),
                element: <UserAgreementDetails />,
              },
              {
                path:paths.activeAgreement,
                element:<ActiveAgreement/>
              },
              {
                path: paths.apiKeys,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_APIKEYS}
                    fallback={<Unauthorised />}
                  >
                    <ApiKeys />
                  </Guard>
                ),
              },
              {
                path: paths.clientIds,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_CLIENTIDS}
                    fallback={<Unauthorised />}
                  >
                    <ClientIDs />
                  </Guard>
                ),
              },
              {
                path: paths.calendar,
                element: <Calendar />,
              },
              {
                path: paths.chat,
                element: <Chat />,
              },
            ],
          },
        ],
      },
      {
        path: "/",
        element: (
          <ProtectedRoute>
            <VerticalNavLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            path: paths.verticalNavLayout,
            element: <Dashboard />,
          },
        ],
      },
      {
        path: "/",
        element: (
          <ProtectedRoute>
            <TopNavLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            path: paths.topNavLayout,
            element: <Dashboard />,
          },
        ],
      },
      {
        path: "/",
        element: (
          <ProtectedRoute>
            <ComboNavLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            path: paths.comboNavLayout,
            element: <Dashboard />,
          },
        ],
      },
      {
        path: "/",
        element: (
          <ProtectedRoute>
            <DoubleTopNavLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            path: paths.doubleTopNavLayout,
            element: <Dashboard />,
          },
        ],
      },
      {
        path: "*",
        element: <Navigate to={paths.error404} replace />,
      },
    ],
  },
];

export const router = createBrowserRouter(routes, {
  basename: process.env.PUBLIC_URL,
});

export default routes;
